export enum DocumentEntities{
    VEHICLE,
    DRIVER,
    CUSTOMER
}